import { Component, OnInit } from '@angular/core';
import { SessionService } from '../../shared/services/session/session.service';

@Component({
  selector: 'vit-funds-dialog',
  templateUrl: './funds-dialog.component.html',
  styleUrls: ['./funds-dialog.component.scss']
})
export class FundsDialogComponent implements OnInit {

  constructor(public sessionService: SessionService) {
  }

  ngOnInit() {
  }

  close(): void {
    this.sessionService.hideFundsDialogs();
  }

}



// WEBPACK FOOTER //
// C:/Program Files (x86)/Jenkins/workspace/tss-keno-web/vit-keno/src/app/punter-bar/funds-dialog/funds-dialog.component.ts